import { Warehouse, Sprout, ArrowRight } from "lucide-react";
import Listings from "@/pages/Listings";
import { imageUrl } from "@/lib/api";

export function Wholesale() {
  return (
    <div>
      <section className="relative overflow-hidden bg-slate-900 text-white">
        <img src={imageUrl("https://images.unsplash.com/photo-1553413077-190dd305871c?w=1400&q=80")} alt=""
          className="absolute inset-0 h-full w-full object-cover opacity-30" />
        <div className="relative mx-auto max-w-7xl px-6 py-14">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-indigo-500 px-3 py-1 text-xs font-bold">
            <Warehouse size={14} /> TOPTAN & LOT
          </span>
          <h1 className="mt-3 font-display text-4xl font-extrabold tracking-tighter sm:text-5xl">Toptan Fırsatlar</h1>
          <p className="mt-3 max-w-2xl text-lg text-slate-200">
            Palet satışları, lot ürünler, stok fazlası, fabrika fazlası ve depo tasfiyesi — toptan alımın tüm avantajları tek yerde.
          </p>
        </div>
      </section>
      <Listings fixed={{ is_wholesale: "true" }} heading="Toptan İlanlar" subheading="Palet, lot ve depo fazlası ürünler" />
    </div>
  );
}

export function Agriculture() {
  return (
    <div>
      <section className="relative overflow-hidden bg-emerald-900 text-white">
        <img src={imageUrl("https://images.unsplash.com/photo-1560493676-04071c5f467b?w=1400&q=80")} alt=""
          className="absolute inset-0 h-full w-full object-cover opacity-30" />
        <div className="relative mx-auto max-w-7xl px-6 py-14">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-emerald-500 px-3 py-1 text-xs font-bold text-emerald-950">
            <Sprout size={14} /> ÜRETİCİ DOSTU
          </span>
          <h1 className="mt-3 font-display text-4xl font-extrabold tracking-tighter sm:text-5xl">Tarlada Kalan Ürünler</h1>
          <p className="mt-3 max-w-2xl text-lg text-emerald-100">
            Piyasa fiyatı maliyetin altına düştüğünde hasat edilemeyen ürünler burada değer buluyor. Üreticiden alıcıya doğrudan.
          </p>
        </div>
      </section>
      <Listings fixed={{ is_agriculture: "true" }} agriculture heading="Tarladan Fırsatlar" subheading="Üretici elinden taze ürünler" />
    </div>
  );
}
